var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 27.429,
    viewBox: "0 0 24.001 27.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.923,13.029a1.4,1.4,0,1,1-1.4-1.522A1.461,1.461,0,0,1,15.923,13.029Zm-6.4-1.522a1.528,1.528,0,0,0,0,3.045,1.461,1.461,0,0,0,1.4-1.522A1.452,1.452,0,0,0,9.518,11.507ZM24,2.825v24.6c-3.455-3.053-2.35-2.043-6.364-5.774l.727,2.537H2.812A2.818,2.818,0,0,1,0,21.368V2.825A2.818,2.818,0,0,1,2.812,0H21.189A2.818,2.818,0,0,1,24,2.825Zm-3.909,13a18.366,18.366,0,0,0-1.975-8,6.782,6.782,0,0,0-3.854-1.44l-.192.219a9.127,9.127,0,0,1,3.415,1.742,11.653,11.653,0,0,0-10.245-.4c-.507.233-.809.4-.809.4a9.252,9.252,0,0,1,3.607-1.8L9.9,6.391a6.782,6.782,0,0,0-3.854,1.44,18.366,18.366,0,0,0-1.975,8,4.973,4.973,0,0,0,4.183,2.085s.507-.617.919-1.138a4.265,4.265,0,0,1-2.4-1.618c.2.141.534.324.562.343a10,10,0,0,0,8.558.48,7.848,7.848,0,0,0,1.577-.809A4.328,4.328,0,0,1,14.99,16.8c.411.521.905,1.111.905,1.111A5.013,5.013,0,0,0,20.092,15.827Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.55beb4f0fe745699e167daad234d622f.svg";
export { ForwardRef as ReactComponent };